export default __webpack_public_path__ + "static/media/flag2.0e6e68ba.jpg";